export default {
    message: {
        currencySymbol: "$",
        currencyDesc: "USD",
        tiers: {
            t1: {
                label: "Workspace Standard",
                desc: "<p>Podstawowe środowisko pracy oferujące inteligentne funkcje dla współczesnych pracowników korzystających z usług typu oprogramowanie jako usługa (SaaS), aplikacji internetowych i usług współdzielenia plików.</p><p>Obejmuje logowanie jednokrotne (SSO) z obsługą wieloskładnikowego uwierzytelnienia dla wszystkich aplikacji, inteligentną przestrzeń roboczą z mikroaplikacjami, spersonalizowanym strumieniem danych i pomocą wirtualną; oraz usługę Citrix Content Collaboration Standard z nieograniczoną przestrzenią pamięci plików.</p>"
            },
            t2: {
                label: "Workspace Premium",
                desc: "<p>Kompletne rozwiązanie z zakresu środowiska pracy dla pracowników, którzy potrzebują kompletnego wirtualnego środowiska pracy ze szczegółową konfiguracją bezpieczeństwa, ale którzy nie potrzebują wirtualnych aplikacji ani desktopów.</p><p>Obejmuje funkcjonalność Workspace Standard oraz zaawansowane parametry bezpieczeństwa SaaS i sieciowe, ujednolicone zarządzanie punktami końcowymi oraz Content Collaboration Premium.</p>"
            },
            t3: {
                label: "Workspace Premium Plus",
                desc: "<p>Wszechstronne rozwiązanie środowiska pracy obejmujące opcje wdrożenia hybrydowego dla usług Citrix Virtual Apps and Desktops.</p><p>Obejmuje funkcjonalność Workspace Premium oraz opcję zarządzania chmurą dla usług Citrix Virtual Apps and Desktops.</p>"
            },
            t4: {
                label: "Workspace Essentials",
                desc: "<p>Usługa Citrix Workspace Essentials pomaga małym i średnim przedsiębiorstwom chronić swoje dane, upraszczając i zabezpieczając proces logowania do aplikacji SaaS i internetowych.</p><p>Zapewnia możliwość jednokrotnego logowania do aplikacji SaaS i internetowych z uwierzytelnianiem wieloskładnikowym w celu dalszego zabezpieczenia procesu logowania, pozwalając na zmniejszenie prawdopodobieństwa naruszenia bezpieczeństwa konta o 99,9%.</p>"
            },
            terms: "* Na użytkownika miesięcznie",
            btn1: "Wyświetl tabelę funkcji"
        },
        features: {
            disclaimer1: "* Średnia sugerowana cena detaliczna producenta w USD za użytkownika dla 500 użytkowników za 3-letnią subskrypcję. Ceny rzeczywiste mogą się różnić.<br /> Opcje licencjonowania Citrix Workspace dostępne są dla minimum 25 użytkowników.",
            disclaimer2: "** Usługa Workspace Premium nie obejmuje rozwiązania Workspace Analytics w przypadku wdrożeń lokalnych usługi Citrix Virtual Apps and Desktops."
        },
        calculator: {
            edition: "Wybierz wydanie",
            title: "Oblicz swoją cenę",
            users: "Wybierz liczbę użytkowników",
            estCost: "Szacowany koszt miesięczny",
            btn1: "Porozmawiaj ze specjalistą",
            btn1_link: "/products/citrix-workspace/form/pricing-inquiry/",
            minUserMsg: "Opcje licencjonowania dostępne są dla minimum 25 użytkowników. Spróbuj ponownie.",
            lowUserMsg: "Masz mniej niż 500 użytkowników? Możemy pomóc Ci zaspokoić potrzeby Twojej małej lub średniej firmy.",
            volumeDiscount: "Masz ponad 2500 użytkowników? Skorzystaj z obniżonej ceny licencji zbiorowych.",
            contract1: "Umowa na rok",
            contract3: "Umowa na trzy lata",
            contract3savings: "Oszczędność 20%",
            term: "Na użytkownika miesięcznie",
            disclaimer: "* Kalkulator zapewnia szacunkowe obliczenia ceny i jest używany wyłącznie w celach planowania wydatków. Ceny rzeczywiste mogą się różnić. Skontaktuj się z zespołem Citrix lub partnerem, aby uzyskać zniżkę."
        },
        stats: {
            title: "Twoje korzyści",
            stat1: {
                title: "Popraw możliwości użytkowników",
                desc: "<b>4 z 5</b> liderów w branży IT jest zdania, że możliwości pracowników mają istotne znaczenie dla sukcesu transformacji cyfrowej organizacji."
            },
            stat2: {
                title: "Daj pracownikom wybór",
                desc: "<b>78%</b> liderów biznesu podziela pogląd, że umożliwienie pracownikom wyboru używanych aplikacji i urządzeń zwiększa ich produktywność."
            },
            stat3: {
                title: "Uprość dostęp",
                desc: "<b>47%</b> liderów biznesu jest zdania, że największe znaczenie w zwiększaniu zaangażowania pracowników ma łatwość dostępu do informacji niezbędnych do pracy."
            },
            btn1: "Porozmawiaj ze specjalistą",
            disclaimer: "Źródło: <a href='https://theexperienceofwork.economist.com/Citrix_The_Experience_of_Work_BriefingPaper.pdf' target='_blank'>The Economist</a>"
        }
    }
}